import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { ChartTooltipSubTitle } from "@similarweb/ui-components";

import { WidgetFooterContainer } from "app/components/React/WidgetContainer/styledComponents";
import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";

export const StyledWidgetContainer = styled(WidgetContainer)`
    width: 100%;
    height: 460px;
`;

export const StyledWidgetFooterContainer = styled(WidgetFooterContainer)`
    height: 58px;
`;

export const ChartTooltipWrapper = styled.div<{ isIntersection: boolean }>`
    ${({ isIntersection }) =>
        !isIntersection &&
        css`
            ${ChartTooltipSubTitle} {
                margin-bottom: 0;
            }
        `}
`;

export const TooltipTitleContainer = styled.div`
    padding-bottom: 16px;
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
`;

export const TooltipTitleText = styled.div`
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])}
`;
